///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Routes } from '@angular/router';
import { UserAuthorities } from '../services/user/user-authorities';
import { CreateUserDialogWrapperComponent } from './dialogs/create-or-edit/create-user-dialog-wrapper.component';
import { EditUserDialogWrapperComponent } from './dialogs/create-or-edit/edit-user-dialog-wrapper.component';
import { DeleteUserDialogWrapperComponent } from './dialogs/delete/delete-user-dialog-wrapper.component';
import { DialogAction } from '../dialog-manager/dialog-action-enum';
import { canActivateUser } from '../shared/auth/user-route-access-service';
import { DeleteSaleDialogWrapperComponent } from './dialogs/delete/delete-sale-dialog-wrapper.component';

export const gridPopupsRoute: Routes = [
    {
        path: `${DialogAction.CREATE}/accountants`,
        component: CreateUserDialogWrapperComponent,
        outlet: 'popup',
        data: {
            authorities: [UserAuthorities.SIKLU_ADMIN, UserAuthorities.SIKLU_ACCOUNTANT]
        },
        canActivate: [canActivateUser]
    },
    {
        path: `${DialogAction.CREATE}/customersSupport`,
        component: CreateUserDialogWrapperComponent,
        outlet: 'popup',
        data: {
            authorities: [UserAuthorities.SIKLU_ADMIN, UserAuthorities.SIKLU_ACCOUNTANT, UserAuthorities.SIKLU_CUSTOMER_SUPPORT]
        },
        canActivate: [canActivateUser]
    },
    {
        path: `${DialogAction.CREATE}/sales`,
        component: CreateUserDialogWrapperComponent,
        outlet: 'popup',
        data: {
            authorities: UserAuthorities.ALL_SIKLU
        },
        canActivate: [canActivateUser]
    },
    {
        path: `${DialogAction.CREATE}/users`,
        component: CreateUserDialogWrapperComponent,
        outlet: 'popup',
        data: {
            authorities: [UserAuthorities.COMPANY_ADMIN]
        },
        canActivate: [canActivateUser]
    },
    {
        path: `${DialogAction.CREATE}/customers/:customerId`,
        component: CreateUserDialogWrapperComponent,
        outlet: 'popup',
        data: {
            authorities: UserAuthorities.ALL_SIKLU
        },
        canActivate: [canActivateUser]
    },
    {
        path: `${DialogAction.EDIT}/user/:id`,
        component: EditUserDialogWrapperComponent,
        outlet: 'popup',
        data: {
            authorities: [
                UserAuthorities.SIKLU_ADMIN,
                UserAuthorities.SIKLU_ACCOUNTANT,
                UserAuthorities.SIKLU_CUSTOMER_SUPPORT,
                UserAuthorities.SIKLU_SALES,
                UserAuthorities.COMPANY_ADMIN
            ]
        },
        canActivate: [canActivateUser]
    },
    {
        path: `${DialogAction.DELETE}/user/:id`,
        component: DeleteUserDialogWrapperComponent,
        outlet: 'popup',
        data: {
            authorities: [
                UserAuthorities.SIKLU_ADMIN,
                UserAuthorities.SIKLU_ACCOUNTANT,
                UserAuthorities.SIKLU_CUSTOMER_SUPPORT,
                UserAuthorities.SIKLU_SALES,
                UserAuthorities.COMPANY_ADMIN
            ]
        },
        canActivate: [canActivateUser]
    },
    {
        path: `${DialogAction.DELETE}/sale/:id`,
        component: DeleteSaleDialogWrapperComponent,
        outlet: 'popup',
        data: {
            authorities: [
                UserAuthorities.SIKLU_ADMIN,
                UserAuthorities.SIKLU_ACCOUNTANT,
                UserAuthorities.SIKLU_CUSTOMER_SUPPORT,
                UserAuthorities.SIKLU_SALES
            ]
        },
        canActivate: [canActivateUser]
    }
];
